import React, {
  useState,
  useContext,
} from "react";

import {
  CustomerContext,
} from "../context/CustomerContext";

import { useNavigate } from "react-router-dom";

import {
  FaUser,
  FaShieldAlt,
  FaIdCard,
  FaSave,
} from "react-icons/fa";

import "../styles/AddCustomer.css";

function AddCustomer() {

  const {
  customers,
  setCustomers,
  addCustomer
} = useContext(
  CustomerContext
);

  const editingCustomer =
  JSON.parse(
    localStorage.getItem(
      "editingCustomer"
    )
  );

  const navigate = useNavigate();


  const [formData,
setFormData] =
useState(

  editingCustomer || {

    name: "",
    phone: "",
    email: "",
    address: "",
    gst: "",
    pan: "",
    notes: "",

    customerType:
      "Home Gardener",

    loyalty:
      "Green Sprout (Basic)",

    points: 0,

  }

);
  const handleChange = (
    e
  ) => {

    setFormData({

      ...formData,

      [e.target.name]:
        e.target.value,

    });

  };

  

const handleSave = async () => {

  try {

    if (editingCustomer) {

      const updatedCustomers =
        customers.map((c) =>

          c.phone ===
          editingCustomer.phone

            ? formData

            : c

        );

      setCustomers(
        updatedCustomers
      );

      localStorage.removeItem(
        "editingCustomer"
      );

    } else {

      await addCustomer(
        formData
      );

    }

    navigate("/customers");

  } catch (error) {

    console.error(error);

    alert(
      "Failed to save customer"
    );

  }

};

  return (

    <div className="add-customer-page">

      <div className="page-header">

        <h1>
          Customer Registration
        </h1>

        <p>
          Create a new profile
          for retail or wholesale
          gardening partners.
        </p>

      </div>

      {/* TOP SECTION */}

      <div className="top-grid">

        {/* BASIC */}

        <div className="card large-card">

          <div className="card-title">

            <FaUser />

            <span>
              Basic Information
            </span>

          </div>

          <div className="form-row">

            <div>

              <label>
                FULL NAME
              </label>

              <input
                type="text"
                name="name"
                placeholder="Enter customer's full name"
                value={
                  formData.name
                }
                onChange={
                  handleChange
                }
              />

            </div>

            <div>

              <label>
                CUSTOMER ID
              </label>

              <input
                type="text"
                value="CUST-2026-1001"
                disabled
              />

            </div>

          </div>

          <label>
            CUSTOMER TYPE
          </label>

          <div className="type-buttons">

            {[
              "Home Gardener",
              "Landscaper",
              "Wholesale",
            ].map((type) => (

              <button
                key={type}
                className={
                  formData.customerType === type
                    ? "active-type"
                    : ""
                }
                onClick={() =>
                  setFormData({
                    ...formData,
                    customerType:
                      type,
                  })
                }
              >
                {type}
              </button>

            ))}

          </div>

        </div>

        {/* LOYALTY */}

        <div className="card">

          <div className="card-title">

            <FaShieldAlt />

            <span>
              Loyalty
            </span>

          </div>

          <label>
            MEMBERSHIP TIER
          </label>

          <select
            name="loyalty"
            value={
              formData.loyalty
            }
            onChange={
              handleChange
            }
          >

            <option>
              Green Sprout (Basic)
            </option>

            <option>
              Gold Member
            </option>

            <option>
              Platinum Member
            </option>

          </select>

          <label>
            INITIAL POINTS
          </label>

          <input
            type="number"
            name="points"
            value={
              formData.points
            }
            onChange={
              handleChange
            }
          />

          <div className="info-box">

            Points will be applied
            after the first
            purchase.

          </div>

        </div>

      </div>

      {/* CONTACT + GST */}

      <div className="bottom-grid">

        {/* CONTACT */}

        <div className="card">

          <div className="card-title">

            <FaIdCard />

            <span>
              Contact Details
            </span>

          </div>

          <div className="form-row">

            <div>

              <label>
                PHONE NUMBER
              </label>

              <input
                type="text"
                name="phone"
                placeholder="+91 00000 00000"
                value={
                  formData.phone
                }
                onChange={
                  handleChange
                }
              />

            </div>

            <div>

              <label>
                EMAIL ADDRESS
              </label>

              <input
                type="email"
                name="email"
                placeholder="example@garden.com"
                value={
                  formData.email
                }
                onChange={
                  handleChange
                }
              />

            </div>

          </div>

          <label>
            BILLING ADDRESS
          </label>

          <textarea
            name="address"
            placeholder="Street, Building, City, State, PIN"
            value={
              formData.address
            }
            onChange={
              handleChange
            }
          />

        </div>

        {/* GST */}

        <div className="card">

          <div className="card-title">

            <FaShieldAlt />

            <span>
              Tax & GST Information
            </span>

          </div>

          <label>
            GSTIN
          </label>

          <input
            type="text"
            name="gst"
            placeholder="27AAAAA0000A1Z5"
            value={
              formData.gst
            }
            onChange={
              handleChange
            }
          />

          <label>
            PAN NUMBER
          </label>

          <input
            type="text"
            name="pan"
            placeholder="ABCDE1234F"
            value={
              formData.pan
            }
            onChange={
              handleChange
            }
          />

          <div className="info-box">

            GSTIN will be verified
            during checkout.

          </div>

        </div>

      </div>

      {/* NOTES */}

      <div className="card notes-card">

        <div className="card-title">

          <FaIdCard />

          <span>
            Gardening Preferences & Internal Notes
          </span>

        </div>

        <label>
          CUSTOMER NOTES
        </label>

        <textarea
          name="notes"
          placeholder="Mention preferred plants, soil types, bulk purchase schedule..."
          value={
            formData.notes
          }
          onChange={
            handleChange
          }
        />

      </div>

      {/* ACTIONS */}

      <div className="action-buttons">

        <button className="cancel-btn">
          Cancel
        </button>

        <button
          className="save-btn"
          onClick={handleSave}
        >

          <FaSave />

          Save Customer

        </button>

      </div>

    </div>
  );
}

export default AddCustomer;